import { useStore } from "..";
export function useServiceStore(service, selector) {
    return useStore(service.store, selector);
}
//# sourceMappingURL=useServiceStore.js.map